import React from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { rows } from "./data";

const bayLocations = [...new Set(rows.map((row) => row.bayLocation))];
const activeStatuses = ["Active", "Inactive", "Under Threshold"];

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Stock Code
        </InputLabel>
        <TextField
          variant="outlined"
          name="code"
          value={filterData.code}
          onChange={handleChangeFilter("code")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Description
        </InputLabel>
        <TextField
          variant="outlined"
          name="description"
          value={filterData.description}
          onChange={handleChangeFilter("description")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Active
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.active}
            onChange={(e) => handleChangeFilter("active")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="">All</MenuItem>
            {activeStatuses.map((status) => (
              <MenuItem key={status} value={status}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Qty Min
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.inventoryMin}
          onChange={handleChangeFilter("inventoryMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Qty Max
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.inventoryMax}
          onChange={handleChangeFilter("inventoryMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Threshold Value Min
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.thresholdValueMin}
          onChange={handleChangeFilter("thresholdValueMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Threshold Value Max
        </InputLabel>
        <TextField
          variant="outlined"
          type="number"
          value={filterData.thresholdValueMax}
          onChange={handleChangeFilter("thresholdValueMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Bay Location
        </InputLabel>
        <Autocomplete
          disablePortal
          options={bayLocations}
          value={filterData.bayLocation}
          onChange={(_, newValue) =>
            handleChangeFilter("bayLocation")(newValue)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleFilter();
              }}
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Last Synced Start
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.lastSyncedStart}
            onChange={handleChangeFilter("lastSyncedStart")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Last Synced End
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.lastSyncedEnd}
            onChange={handleChangeFilter("lastSyncedEnd")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
